import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/swipez--toggle--shape.svg'
import _imports_1 from '@/assets/img/swipez--sqaure--shape.svg'
import _imports_2 from '@/assets/img/Swipez--text--logo.svg'


const _hoisted_1 = { class: "w-layout-hflex header is--dark is--policy" }
const _hoisted_2 = { class: "w-layout-hflex header--wrapper" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<a href=\"/\" class=\"brand w-inline-block\"><div class=\"sign--wrapper\"><div class=\"toggle--wrapper\"><img src=\"" + _imports_0 + "\" loading=\"lazy\" alt=\"\" class=\"sign--toggle\"></div><img src=\"" + _imports_1 + "\" loading=\"lazy\" alt=\"\" class=\"sign--square\"></div><div class=\"w-layout-hflex swipez--text--wrapper\"><img src=\"" + _imports_2 + "\" loading=\"lazy\" alt=\"Swipez logotype\" class=\"swipez--text--logo\"></div></a>", 1)
const _hoisted_4 = {
  "data-w-id": "2bc61cb3-c810-a306-521f-0ec5dbac2c62",
  class: "cta--wrapper is--policy"
}
const _hoisted_5 = {
  href: "/",
  class: "button w-inline-block"
}
const _hoisted_6 = {
  "data-w-id": "72fa98d1-19f4-83d1-4385-6e838d8fa27b",
  class: "hero is--policy"
}
const _hoisted_7 = { class: "w-layout-hflex global--padding" }
const _hoisted_8 = { class: "global--wrapper is--footer" }
const _hoisted_9 = { class: "w-layout-vflex policy--wrapper" }

import Header from "./Header.vue";
import Footer from "./Footer.vue";
import { useI18n } from "vue-i18n";
import { onMounted, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentLayout',
  setup(__props) {

const { locale } = useI18n();
const curLang = ref("cz");
onMounted(async () => {
  curLang.value = localStorage.getItem("locale") || "cz";
  locale.value = curLang.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", _hoisted_5, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("Back to website")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ])
        ])
      ])
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})